export enum VendorPortalEvents {
  INSURED_INSERT = 'INSURED_INSERT',
  INSURED_UPDATE = 'INSURED_UPDATE',
  INSURED_DELETE = 'INSURED_DELETE',

  PROSPECT_INSERT = 'PROSPECT_INSERT',
  PROSPECT_UPDATE = 'PROSPECT_UPDATE',
  PROSPECT_DELETE = 'PROSPECT_DELETE',

  REFERRAL_INSERT = 'REFERRAL_INSERT',
  REFERRAL_UPDATE = 'REFERRAL_UPDATE',
  REFERRAL_DELETE = 'REFERRAL_DELETE',

  POLICY_INSERT = 'POLICY_INSERT',
  POLICY_UPDATE = 'POLICY_UPDATE',
  POLICY_DELETE = 'POLICY_DELETE',

  QUOTE_INSERT = 'QUOTE_INSERT',
  QUOTE_UPDATE = 'QUOTE_UPDATE',
  QUOTE_DELETE = 'QUOTE_DELETE',

  NOTE_INSERT = 'NOTE_INSERT',
  NOTE_UPDATE = 'NOTE_UPDATE',
  NOTE_DELETE = 'NOTE_DELETE',

  TASK_INSERT = 'TASK_INSERT',
  TASK_UPDATE = 'TASK_UPDATE',
  TASK_DELETE = 'TASK_DELETE',

  MGA_INSERT = 'MGA_INSERT',
  MGA_UPDATE = 'MGA_UPDATE',
  MGA_DELETE = 'MGA_DELETE',

  CARRIER_INSERT = 'CARRIER_INSERT',
  CARRIER_UPDATE = 'CARRIER_UPDATE',
  CARRIER_DELETE = 'CARRIER_DELETE',

  FINANCECOMPANY_INSERT = 'FINANCECOMPANY_INSERT',
  FINANCECOMPANY_UPDATE = 'FINANCECOMPANY_UPDATE',
  FINANCECOMPANY_DELETE = 'FINANCECOMPANY_DELETE',

  REFERRALSOURCE_INSERT = 'REFERRALSOURCE_INSERT',
  REFERRALSOURCE_UPDATE = 'REFERRALSOURCE_UPDATE',
  REFERRALSOURCE_DELETE = 'REFERRALSOURCE_DELETE',

  OTHERTRUCKINGCOMPANY_INSERT = 'OTHERTRUCKINGCOMPANY_INSERT',
  OTHERTRUCKINGCOMPANY_UPDATE = 'OTHERTRUCKINGCOMPANY_UPDATE',
  OTHERTRUCKINGCOMPANY_DELETE = 'OTHERTRUCKINGCOMPANY_DELETE',

  DRIVER_INSERT = 'DRIVER_INSERT',
  DRIVER_UPDATE = 'DRIVER_UPDATE',
  DRIVER_DELETE = 'DRIVER_DELETE',

  TRUCKINGCOMPANYOPPORTUNITY_INSERT = 'TRUCKINGCOMPANYOPPORTUNITY_INSERT',
  TRUCKINGCOMPANYOPPORTUNITY_UPDATE = 'TRUCKINGCOMPANYOPPORTUNITY_UPDATE',
  TRUCKINGCOMPANYOPPORTUNITY_DELETE = 'TRUCKINGCOMPANYOPPORTUNITY_DELETE',

  OTHERCLAIM_INSERT = 'OTHERCLAIM_INSERT',
  OTHERCLAIM_UPDATE = 'OTHERCLAIM_UPDATE',
  OTHERCLAIM_DELETE = 'OTHERCLAIM_DELETE',

  GENERALLIABILITYCLAIM_INSERT = 'GENERALLIABILITYCLAIM_INSERT',
  GENERALLIABILITYCLAIM_UPDATE = 'GENERALLIABILITYCLAIM_UPDATE',
  GENERALLIABILITYCLAIM_DELETE = 'GENERALLIABILITYCLAIM_DELETE',

  PROPERTYLOSSCLAIM_INSERT = 'PROPERTYLOSSCLAIM_INSERT',
  PROPERTYLOSSCLAIM_UPDATE = 'PROPERTYLOSSCLAIM_UPDATE',
  PROPERTYLOSSCLAIM_DELETE = 'PROPERTYLOSSCLAIM_DELETE',

  WORKERCOMPENSATIONCLAIM_INSERT = 'WORKERCOMPENSATIONCLAIM_INSERT',
  WORKERCOMPENSATIONCLAIM_UPDATE = 'WORKERCOMPENSATIONCLAIM_UPDATE',
  WORKERCOMPENSATIONCLAIM_DELETE = 'WORKERCOMPENSATIONCLAIM_DELETE',

  VEHICLE_INSERT = 'VEHICLE_INSERT',
  VEHICLE_UPDATE = 'VEHICLE_UPDATE',
  VEHICLE_DELETE = 'VEHICLE_DELETE',

  TAGAPPLY_INSERT = 'TAGAPPLY_INSERT',
  TAGAPPLY_UPDATE = 'TAGAPPLY_UPDATE',
  TAGAPPLY_DELETE = 'TAGAPPLY_DELETE',

  PRINCIPAL_INSERT = 'PRINCIPAL_INSERT',
  PRINCIPAL_UPDATE = 'PRINCIPAL_UPDATE',
  PRINCIPAL_DELETE = 'PRINCIPAL_DELETE',

  PENDINGCANCELLATION_INSERT = 'PENDINGCANCELLATION_INSERT',
  PENDINGCANCELLATION_UPDATE = 'PENDINGCANCELLATION_UPDATE',
  PENDINGCANCELLATION_DELETE = 'PENDINGCANCELLATION_DELETE',

  PROPERTY_INSERT = 'PROPERTY_INSERT',
  PROPERTY_UPDATE = 'PROPERTY_UPDATE',
  PROPERTY_DELETE = 'PROPERTY_DELETE',

  MASTERCERTIFICATE_INSERT = 'MASTERCERTIFICATE_INSERT',
  MASTERCERTIFICATE_UPDATE = 'MASTERCERTIFICATE_UPDATE',
  MASTERCERTIFICATE_DELETE = 'MASTERCERTIFICATE_DELETE',

  AGENT_INSERT = 'AGENT_INSERT',
  AGENT_UPDATE = 'AGENT_UPDATE',
  AGENT_DELETE = 'AGENT_DELETE',

  TAGAPPLYONPOLICY_INSERT = 'TAGAPPLYONPOLICY_INSERT',
  TAGAPPLYONPOLICY_UPDATE = 'TAGAPPLYONPOLICY_UPDATE',
  TAGAPPLYONPOLICY_DELETE = 'TAGAPPLYONPOLICY_DELETE',

  TAG_INSERT = 'TAG_INSERT',
  TAG_UPDATE = 'TAG_UPDATE',
  TAG_DELETE = 'TAG_DELETE',

  INSURANCEAGENCY_INSERT = 'INSURANCEAGENCY_INSERT',
  INSURANCEAGENCY_UPDATE = 'INSURANCEAGENCY_UPDATE',
  INSURANCEAGENCY_DELETE = 'INSURANCEAGENCY_DELETE',

  OPPORTUNITYSTAGE_INSERT = 'OPPORTUNITYSTAGE_INSERT',
  OPPORTUNITYSTAGE_UPDATE = 'OPPORTUNITYSTAGE_UPDATE',
  OPPORTUNITYSTAGE_DELETE = 'OPPORTUNITYSTAGE_DELETE',

  AUTOMOBILELOSSCLAIM_INSERT = 'AUTOMOBILELOSSCLAIM_INSERT',
  AUTOMOBILELOSSCLAIM_UPDATE = 'AUTOMOBILELOSSCLAIM_UPDATE',
  AUTOMOBILELOSSCLAIM_DELETE = 'AUTOMOBILELOSSCLAIM_DELETE',

  SERVICEREQUESTPOLICYCHANGE_INSERT = 'SERVICEREQUESTPOLICYCHANGE_INSERT',
  SERVICEREQUESTPOLICYCHANGE_UPDATE = 'SERVICEREQUESTPOLICYCHANGE_UPDATE',
  SERVICEREQUESTPOLICYCHANGE_DELETE = 'SERVICEREQUESTPOLICYCHANGE_DELETE',

  SERVICEREQUESTADDDRIVER_INSERT = 'SERVICEREQUESTADDDRIVER_INSERT',
  SERVICEREQUESTADDDRIVER_UPDATE = 'SERVICEREQUESTADDDRIVER_UPDATE',
  SERVICEREQUESTADDDRIVER_DELETE = 'SERVICEREQUESTADDDRIVER_DELETE',

  SERVICEREQUESTADDRESSCHANGE_INSERT = 'SERVICEREQUESTADDRESSCHANGE_INSERT',
  SERVICEREQUESTADDRESSCHANGE_UPDATE = 'SERVICEREQUESTADDRESSCHANGE_UPDATE',
  SERVICEREQUESTADDRESSCHANGE_DELETE = 'SERVICEREQUESTADDRESSCHANGE_DELETE',

  SERVICEREQUESTREMOVEDRIVER_INSERT = 'SERVICEREQUESTREMOVEDRIVER_INSERT',
  SERVICEREQUESTREMOVEDRIVER_UPDATE = 'SERVICEREQUESTREMOVEDRIVER_UPDATE',
  SERVICEREQUESTREMOVEDRIVER_DELETE = 'SERVICEREQUESTREMOVEDRIVER_DELETE',

  SERVICEREQUESTREPLACEDRIVER_INSERT = 'SERVICEREQUESTREPLACEDRIVER_INSERT',
  SERVICEREQUESTREPLACEDRIVER_UPDATE = 'SERVICEREQUESTREPLACEDRIVER_UPDATE',
  SERVICEREQUESTREPLACEDRIVER_DELETE = 'SERVICEREQUESTREPLACEDRIVER_DELETE',

  SERVICEREQUESTVEHICLETRANSFER_INSERT = 'SERVICEREQUESTVEHICLETRANSFER_INSERT',
  SERVICEREQUESTVEHICLETRANSFER_UPDATE = 'SERVICEREQUESTVEHICLETRANSFER_UPDATE',
  SERVICEREQUESTVEHICLETRANSFER_DELETE = 'SERVICEREQUESTVEHICLETRANSFER_DELETE',

  SERVICEREQUESTGENERALNEW_INSERT = 'SERVICEREQUESTGENERALNEW_INSERT',
  SERVICEREQUESTGENERALNEW_UPDATE = 'SERVICEREQUESTGENERALNEW_UPDATE',
  SERVICEREQUESTGENERALNEW_DELETE = 'SERVICEREQUESTGENERALNEW_DELETE',

  SERVICEREQUESTGENERIC_INSERT = 'SERVICEREQUESTGENERIC_INSERT',
  SERVICEREQUESTGENERIC_UPDATE = 'SERVICEREQUESTGENERIC_UPDATE',
  SERVICEREQUESTGENERIC_DELETE = 'SERVICEREQUESTGENERIC_DELETE',

  LOB_INSERT = 'LOB_INSERT',
  LOB_UPDATE = 'LOB_UPDATE',
  LOB_DELETE = 'LOB_DELETE',

  GROUP_HEALTH_MEMBER_INSERT = 'GROUP_HEALTH_MEMBER_INSERT',
  GROUP_HEALTH_MEMBER_UPDATE = 'GROUP_HEALTH_MEMBER_UPDATE',
  GROUP_HEALTH_MEMBER_DELETE = 'GROUP_HEALTH_MEMBER_DELETE',

  MOTOR_TRUCK_CARGO_INSERT = 'MOTOR_TRUCK_CARGO_INSERT',
  MOTOR_TRUCK_CARGO_UPDATE = 'MOTOR_TRUCK_CARGO_UPDATE',
  MOTOR_TRUCK_CARGO_DELETE = 'MOTOR_TRUCK_CARGO_DELETE',

  TASK_CATEGORY_INSERT = 'TASK_CATEGORY_INSERT',
  TASK_CATEGORY_UPDATE = 'TASK_CATEGORY_UPDATE',
  TASK_CATEGORY_DELETE = 'TASK_CATEGORY_DELETE',

  ANIMAL_INSERT = 'ANIMAL_INSERT',
  ANIMAL_UPDATE = 'ANIMAL_UPDATE',
  ANIMAL_DELETE = 'ANIMAL_DELETE',

  TODO_INSERT = 'TODO_INSERT',
  TODO_UPDATE = 'TODO_UPDATE',
  TODO_DELETE = 'TODO_DELETE',

  LIFE_INS_INSERT = 'LIFE_INS_INSERT',
  LIFE_INS_UPDATE = 'LIFE_INS_UPDATE',
  LIFE_INS_DELETE = 'LIFE_INS_DELETE',

  XDate_INSERT = 'XDate_INSERT',
  XDate_UPDATE = 'XDate_UPDATE',
  XDate_DELETE = 'XDate_DELETE',

  ENDORSEMENT_INSERT = 'ENDORSEMENT_INSERT',
  ENDORSEMENT_UPDATE = 'ENDORSEMENT_UPDATE',
  ENDORSEMENT_DELETE = 'ENDORSEMENT_DELETE',

  ENDORSEMENT_AGENCY_COMMISSION_INSERT = 'ENDORSEMENT_AGENCY_COMMISSION_INSERT',
  ENDORSEMENT_AGENCY_COMMISSION_UPDATE = 'ENDORSEMENT_AGENCY_COMMISSION_UPDATE',
  ENDORSEMENT_AGENCY_COMMISSION_DELETE = 'ENDORSEMENT_AGENCY_COMMISSION_DELETE',

  ENDORSEMENT_AGENT_COMMISSION_INSERT = 'ENDORSEMENT_AGENT_COMMISSION_INSERT',
  ENDORSEMENT_AGENT_COMMISSION_UPDATE = 'ENDORSEMENT_AGENT_COMMISSION_UPDATE',
  ENDORSEMENT_AGENT_COMMISSION_DELETE = 'ENDORSEMENT_AGENT_COMMISSION_DELETE',

  ENDORSEMENT_RECEIVABLE_INSERT = 'ENDORSEMENT_RECEIVABLE_INSERT',
  ENDORSEMENT_RECEIVABLE_UPDATE = 'ENDORSEMENT_RECEIVABLE_UPDATE',
  ENDORSEMENT_RECEIVABLE_DELETE = 'ENDORSEMENT_RECEIVABLE_DELETE',

  ENDORSEMENT_PAYABLE_INSERT = 'ENDORSEMENT_PAYABLE_INSERT',
  ENDORSEMENT_PAYABLE_UPDATE = 'ENDORSEMENT_PAYABLE_UPDATE',
  ENDORSEMENT_PAYABLE_DELETE = 'ENDORSEMENT_PAYABLE_DELETE',

  ENDORSEMENT_AGENCY_COMMISSION_PAYMENT_INSERT = 'ENDORSEMENT_AGENCY_COMMISSION_PAYMENT_INSERT',
  ENDORSEMENT_AGENCY_COMMISSION_PAYMENT_UPDATE = 'ENDORSEMENT_AGENCY_COMMISSION_PAYMENT_UPDATE',
  ENDORSEMENT_AGENCY_COMMISSION_PAYMENT_DELETE = 'ENDORSEMENT_AGENCY_COMMISSION_PAYMENT_DELETE',

  ENDORSEMENT_AGENTS_COMMISSION_PAYMENT_INSERT = 'ENDORSEMENT_AGENTS_COMMISSION_PAYMENT_INSERT',
  ENDORSEMENT_AGENTS_COMMISSION_PAYMENT_UPDATE = 'ENDORSEMENT_AGENTS_COMMISSION_PAYMENT_UPDATE',
  ENDORSEMENT_AGENTS_COMMISSION_PAYMENT_DELETE = 'ENDORSEMENT_AGENTS_COMMISSION_PAYMENT_DELETE',

  ENDORSEMENT_RECEIVABLE_PAYMENT_INSERT = 'ENDORSEMENT_RECEIVABLE_PAYMENT_INSERT',
  ENDORSEMENT_RECEIVABLE_PAYMENT_UPDATE = 'ENDORSEMENT_RECEIVABLE_PAYMENT_UPDATE',
  ENDORSEMENT_RECEIVABLE_PAYMENT_DELETE = 'ENDORSEMENT_RECEIVABLE_PAYMENT_DELETE',

  ENDORSEMENT_PAYABLE_PAYMENT_INSERT = 'ENDORSEMENT_PAYABLE_PAYMENT_INSERT',
  ENDORSEMENT_PAYABLE_PAYMENT_UPDATE = 'ENDORSEMENT_PAYABLE_PAYMENT_UPDATE',
  ENDORSEMENT_PAYABLE_PAYMENT_DELETE = 'ENDORSEMENT_PAYABLE_PAYMENT_DELETE',

  ENDORSEMENT_FINANCING_INSERT = 'ENDORSEMENT_FINANCING_INSERT',
  ENDORSEMENT_FINANCING_UPDATE = 'ENDORSEMENT_FINANCING_UPDATE',
  ENDORSEMENT_FINANCING_DELETE = 'ENDORSEMENT_FINANCING_DELETE',

  ENDORSEMENT_FINANCING_PAYMENT_INSERT = 'ENDORSEMENT_FINANCING_PAYMENT_INSERT',
  ENDORSEMENT_FINANCING_PAYMENT_UPDATE = 'ENDORSEMENT_FINANCING_PAYMENT_UPDATE',
  ENDORSEMENT_FINANCING_PAYMENT_DELETE = 'ENDORSEMENT_FINANCING_PAYMENT_DELETE',

  ENDORSEMENT_FINANCING_INCENTIVE_INSERT = 'ENDORSEMENT_FINANCING_INCENTIVE_INSERT',
  ENDORSEMENT_FINANCING_INCENTIVE_UPDATE = 'ENDORSEMENT_FINANCING_INCENTIVE_UPDATE',
  ENDORSEMENT_FINANCING_INCENTIVE_DELETE = 'ENDORSEMENT_FINANCING_INCENTIVE_DELETE',

  ENDORSEMENT_FINANCING_INCENTIVE_PAYMENT_INSERT = 'ENDORSEMENT_FINANCING_INCENTIVE_PAYMENT_INSERT',
  ENDORSEMENT_FINANCING_INCENTIVE_PAYMENT_UPDATE = 'ENDORSEMENT_FINANCING_INCENTIVE_PAYMENT_UPDATE',
  ENDORSEMENT_FINANCING_INCENTIVE_PAYMENT_DELETE = 'ENDORSEMENT_FINANCING_INCENTIVE_PAYMENT_DELETE',

  IMPORTANT_DATE_INSERT = 'IMPORTANT_DATE_INSERT',
  IMPORTANT_DATE_UPDATE = 'IMPORTANT_DATE_UPDATE',
  IMPORTANT_DATE_DELETE = 'IMPORTANT_DATE_DELETE',

  PROFESSIONAL_LIABILITY_INSERT = 'PROFESSIONAL_LIABILITY_INSERT',
  PROFESSIONAL_LIABILITY_UPDATE = 'PROFESSIONAL_LIABILITY_UPDATE',
  PROFESSIONAL_LIABILITY_DELETE = 'PROFESSIONAL_LIABILITY_DELETE',

  CERTIFICATE_HOLDER_INSERT = 'CERTIFICATE_HOLDER_INSERT',
  CERTIFICATE_HOLDER_UPDATE = 'CERTIFICATE_HOLDER_UPDATE',
  CERTIFICATE_HOLDER_DELETE = 'CERTIFICATE_HOLDER_DELETE',

  FINANCE_AGREEMENT_INSERT = 'FINANCE_AGREEMENT_INSERT',
  FINANCE_AGREEMENT_UPDATE = 'FINANCE_AGREEMENT_UPDATE',
  FINANCE_AGREEMENT_DELETE = 'FINANCE_AGREEMENT_DELETE',

  EQUIPMENT_INSERT = 'EQUIPMENT_INSERT',
  EQUIPMENT_UPDATE = 'EQUIPMENT_UPDATE',
  EQUIPMENT_DELETE = 'EQUIPMENT_DELETE',

  HOA_UNIT_INSERT = 'HOA_UNIT_INSERT',
  HOA_UNIT_UPDATE = 'HOA_UNIT_UPDATE',
  HOA_UNIT_DELETE = 'HOA_UNIT_DELETE',

  MEDICALHEALTHCLAIM_INSERT = 'MEDICALHEALTHCLAIM_INSERT',
  MEDICALHEALTHCLAIM_UPDATE = 'MEDICALHEALTHCLAIM_UPDATE',
  MEDICALHEALTHCLAIM_DELETE = 'MEDICALHEALTHCLAIM_DELETE',

  REFERRAL_SOURCE_CATEGORY_INSERT = 'REFERRAL_SOURCE_CATEGORY_INSERT',
  REFERRAL_SOURCE_CATEGORY_UPDATE = 'REFERRAL_SOURCE_CATEGORY_UPDATE',
  REFERRAL_SOURCE_CATEGORY_DELETE = 'REFERRAL_SOURCE_CATEGORY_DELETE',

  HISTORICAL_CERTIFICATE_HOLDER_INSERT = 'HISTORICAL_CERTIFICATE_HOLDER_INSERT',
  HISTORICAL_CERTIFICATE_HOLDER_UPDATE = 'HISTORICAL_CERTIFICATE_HOLDER_UPDATE',
  HISTORICAL_CERTIFICATE_HOLDER_DELETE = 'HISTORICAL_CERTIFICATE_HOLDER_DELETE',

  OPPORTUNITY_TRACKING_KEYS_INSERT = 'OPPORTUNITY_TRACKING_KEYS_INSERT',
  OPPORTUNITY_TRACKING_KEYS_UPDATE = 'OPPORTUNITY_TRACKING_KEYS_UPDATE',
  OPPORTUNITY_TRACKING_KEYS_DELETE = 'OPPORTUNITY_TRACKING_KEYS_DELETE',

  WATERCRAFT_INSERT = 'WATERCRAFT_INSERT',
  WATERCRAFT_UPDATE = 'WATERCRAFT_UPDATE',
  WATERCRAFT_DELETE = 'WATERCRAFT_DELETE',

  POLICY_STATUS_CHANGED = 'POLICY_STATUS_CHANGED',

  DIRECT_BILL_AMOUNT_INSERT = 'DIRECT_BILL_AMOUNT_INSERT',
  DIRECT_BILL_AMOUNT_UPDATE = 'DIRECT_BILL_AMOUNT_UPDATE',
  DIRECT_BILL_AMOUNT_DELETE = 'DIRECT_BILL_AMOUNT_DELETE',

  DIRECT_BILL_AMOUNT_PAYMENT_INSERT = 'DIRECT_BILL_AMOUNT_PAYMENT_INSERT',
  DIRECT_BILL_AMOUNT_PAYMENT_UPDATE = 'DIRECT_BILL_AMOUNT_PAYMENT_UPDATE',
  DIRECT_BILL_AMOUNT_PAYMENT_DELETE = 'DIRECT_BILL_AMOUNT_PAYMENT_DELETE',

  INSURED_INVOICE_INSERT = 'INSURED_INVOICE_INSERT',
  INSURED_INVOICE_UPDATE = 'INSURED_INVOICE_UPDATE',

  FLOOD_COVERAGE_INSERT = 'FLOOD_COVERAGE_INSERT',
  FLOOD_COVERAGE_UPDATE = 'FLOOD_COVERAGE_UPDATE',
  FLOOD_COVERAGE_DELETE = 'FLOOD_COVERAGE_DELETE',

  SERVICEREQUESTADDVEHICLE_INSERT = 'SERVICEREQUESTADDVEHICLE_INSERT',
  SERVICEREQUESTADDVEHICLE_UPDATE = 'SERVICEREQUESTADDVEHICLE_UPDATE',
  SERVICEREQUESTADDVEHICLE_DELETE = 'SERVICEREQUESTADDVEHICLE_DELETE',

  SERVICEREQUESTREPLACEVEHICLE_INSERT = 'SERVICEREQUESTREPLACEVEHICLE_INSERT',
  SERVICEREQUESTREPLACEVEHICLE_UPDATE = 'SERVICEREQUESTREPLACEVEHICLE_UPDATE',
  SERVICEREQUESTREPLACEVEHICLE_DELETE = 'SERVICEREQUESTREPLACEVEHICLE_DELETE',

  SERVICEREQUESTCERTIFICATE_OF_INSERT = 'SERVICEREQUESTCERTIFICATE_OF_INSERT',
  SERVICEREQUESTCERTIFICATE_OF_UPDATE = 'SERVICEREQUESTCERTIFICATE_OF_UPDATE',
  SERVICEREQUESTCERTIFICATE_OF_DELETE = 'SERVICEREQUESTCERTIFICATE_OF_DELETE',

  WORKGROUP_INSERT = 'WORKGROUP_INSERT',
  WORKGROUP_UPDATE = 'WORKGROUP_UPDATE',
  WORKGROUP_DELETE = 'WORKGROUP_DELETE',

  CONVERT_PROSPECT_TO_INSURED = 'CONVERT_PROSPECT_TO_INSURED',

  TAGAPPLIESTOOPPORTUNITY_INSERT = 'TAGAPPLIESTOOPPORTUNITY_INSERT',
  TAGAPPLIESTOOPPORTUNITY_UPDATE = 'TAGAPPLIESTOOPPORTUNITY_UPDATE',
  TAGAPPLIESTOOPPORTUNITY_DELETE = 'TAGAPPLIESTOOPPORTUNITY_DELETE',
}
